import React, { Children } from 'react';
const PrivacyPolicy = () => {
  return <div className="w-full" data-id="element-388">
      {/* Header Section */}
      <section className="relative py-20 bg-[#1A5F7A]" data-id="element-389">
        <div className="container mx-auto px-4" data-id="element-390">
          <div className="text-center" data-id="element-391">
            <h1 className="text-4xl font-bold text-white mb-4" data-id="element-392">
              Privacy & Cookie Policy
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-393">
              How we protect and use your information
            </p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-16" data-id="element-394">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-395">
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-396">
            <h2 className="text-2xl font-bold text-[#1A5F7A] mb-6" data-id="element-397">
              Privacy and Cookie Policy - Realmpoint
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-398">
              At Realmpoint, protecting your privacy is a priority. This policy
              explains what information we collect, how we use it, and how we
              keep it secure, ensuring you have confidence in our handling of
              your personal data.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-399">
              1. Who We Are
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-400">
              Realmpoint is a UK-based appliance repair and service company
              specializing in essential household systems.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-401">
              2. What Information We Collect
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-402">
              We may collect the following information from you to provide our
              services and manage your account effectively:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-403">
              <li className="mb-2" data-id="element-404">
                Your name and contact details: Including your address, email
                (bijayathakur8098@gmail.com), and phone number (0800 055 4969).
              </li>
              <li className="mb-2" data-id="element-405">
                Payment information: Processed securely through our trusted
                payment providers.
              </li>
              <li className="mb-2" data-id="element-406">
                Records of your service plans and repair history: To ensure
                continuity of service and support.
              </li>
            </ul>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-407">
              3. How We Use Your Information
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-408">We use your data primarily to:</p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-409">
              <li className="mb-2" data-id="element-410">
                Manage and administer your service plans: Including activation,
                renewals, and plan adjustments.
              </li>
              <li className="mb-2" data-id="element-411">
                Arrange repairs and provide customer support: Dispatching
                engineers and addressing your queries.
              </li>
              <li className="mb-2" data-id="element-412">
                Send important updates and information: Related to your service,
                appointments, and policy changes.
              </li>
              <li className="mb-2" data-id="element-413">
                Comply with legal and regulatory obligations: Ensuring we
                operate within the law.
              </li>
            </ul>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-414">
              4. Third-Party Providers
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-415">
              We work with trusted third parties, such as payment processors and
              website hosting providers, to deliver our services efficiently and
              securely. We want to assure you that we do not sell your personal
              information to any third parties.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-416">
              5. Cookies
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-417">
              Our website uses cookies to enhance your browse experience and
              improve site performance. Cookies are small data files stored on
              your device that help us understand how you interact with our
              site. You can manage or disable cookies through your browser
              settings at any time, but please note this may affect certain
              website functionalities.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-418">
              6. Your Rights
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-419">
              Under applicable data protection laws, you have specific rights
              regarding your personal data. You have the right to:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-600" data-id="element-420">
              <li className="mb-2" data-id="element-421">
                Request access to the personal data we hold about you.
              </li>
              <li className="mb-2" data-id="element-422">
                Ask for corrections or deletion of your data.
              </li>
              <li className="mb-2" data-id="element-423">
                Withdraw your consent to marketing communications at any time.
              </li>
            </ul>
            <p className="text-gray-600 mb-8" data-id="element-424">
              To exercise these rights, please contact us at
              bijayathakur8098@gmail.com or call 0800 055 4969.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-425">
              7. Sharing Your Data
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-426">
              We may share your information with:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-427">
              <li className="mb-2" data-id="element-428">
                Service providers essential to our operations: Such as payment
                processors, IT support, and website hosting services, who act on
                our behalf.
              </li>
              <li className="mb-2" data-id="element-429">
                Law enforcement or regulatory authorities: When required by law
                or in response to a valid legal request.
              </li>
              <li className="mb-2" data-id="element-430">
                Marketing partners: But only with your explicit consent, which
                you can withdraw at any time.
              </li>
            </ul>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-431">
              8. Data Retention
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-432">
              We retain your personal data only as long as necessary to:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-433">
              <li className="mb-2" data-id="element-434">
                Provide and manage our services to you effectively.
              </li>
              <li className="mb-2" data-id="element-435">
                Comply with legal and regulatory requirements.
              </li>
              <li className="mb-2" data-id="element-436">Resolve disputes or complaints.</li>
            </ul>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-437">
              9. Children's Privacy
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-438">
              Our services are not intended for individuals under 16 years old.
              We do not knowingly collect personal data from minors. If we
              become aware that such data has been collected, we will take steps
              to delete it.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-439">
              10. Data Security
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-440">
              We implement strong security measures, including technical and
              organizational safeguards, to protect your information from
              unauthorized access, accidental loss, destruction, or alteration.
              While we strive for robust security, please understand that no
              system can guarantee 100% security during data transmission over
              the internet.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-441">
              11. International Data Transfers
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-442">
              Your data may be stored or processed outside the UK or European
              Economic Area by our service providers. Where this happens, we
              ensure appropriate safeguards are in place to protect your data in
              accordance with relevant data protection laws.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-443">
              12. Updates to This Policy
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-444">
              We may update this privacy policy occasionally to reflect changes
              in our practices, technology, or legal requirements. Any changes
              will be published here with the updated date. We encourage you to
              review this policy regularly to stay informed.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-445">
              13. Contact Us
            </h3>
            <p className="text-gray-600" data-id="element-446">
              If you have any questions or concerns about your data or this
              policy, please do not hesitate to contact us at
              bijayathakur8098@gmail.com or call 0800 055 4969.
            </p>
          </div>
        </div>
      </section>
    </div>;
};
export default PrivacyPolicy;